import VAADIN from "../../assets/vaadin-spring.png";
import SPRING from "../../assets/spring-boot.png";
import PYTHON from "../../assets/python.png";
import SWIFT from "../../assets/swift.png";
import REACT from "../../assets/react.png";

const data = [
  {
    id: 1,
    image: SPRING,
    title: "Bank App",
    github: "https://github.com/emredurrmus/microservice-bank",
  },
  {
    id: 2,
    image: SPRING,
    title: "Forum App",
    github: "https://github.com/emredurrmus/city-app",
  },
  {
    id: 3,
    image: REACT,
    title: "Quiz App",
    github: "https://github.com/emredurrmus/QuizApp",
  },
  {
    id: 4,
    image: PYTHON,
    title: "MoreArts",
    github: "https://github.com/emredurrmus/MoreArts",
  },
  {
    id: 5,
    image: SWIFT,
    title: "Alamofire App",
    github: "https://github.com/emredurrmus/Alamofire_HTTP",
  },
  {
    id: 6,
    image: SWIFT,
    title: "Dice App",
    github: "https://github.com/emredurrmus/DiceApp",
  },
  {
    id: 7,
    image: SWIFT,
    title: "NewsPaper App",
    github: "https://github.com/emredurrmus/NewsPaperApp",
  },
  {
    id: 8,
    image: SWIFT,
    title: "Clima App",
    github: "https://github.com/emredurrmus/ClimaApp",
  },
];

export default data;
